// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_hc-0";
export var fulfillmentPanelBody = "_hc-1";